var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-10",attrs:{"id":"mapping_field__wrapper"}},[_c('h1',[_vm._v("Mappingfelder")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('MappingFieldsConfig')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }